import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { reduxForm } from "redux-form";
import Filters from "../../Utils/Filters/Filters";
import Grid from "../../Utils/Grid";

import "./report-emergency.css";

const List = ({
    listarReport,
    data,
    loader,
    listar,
    descargarExcel,
    start_date,
    setStartDate,
    end_date,
    setEndDate,
    emergency_type_id,
    setTypeEmergency,
    station,
    setStation,
    region,
    setRegion,
    me,
    excelLoading,
    excelProgress,
}) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    useEffect(() => {
        listarReport();
    }, []);

    if (!me.station) {
        NotificationManager.error('No tienes una estación asignada', 'Error', 3000);
    }

    const columns = [
        {
            dataField: "name",
            sort: true,
            text: "Estación",
            formatter: (cell, row) => (
                <div className={row.state === 50 ? "text-danger" : ""}>{row.name}</div>
            ),
        },
        {
            dataField: "region_type",
            sort: true,
            text: "Región",
            formatter: (cell, row) => (
                <div className={row.state === 50 ? "text-danger" : ""}>{row.region_type}</div>
            ),
        },
        {
            dataField: "emergencies_attended",
            sort: true,
            text: "Total de emergencias atendidas",
            formatter: (cell, row) => (
                <div className={row.state === 50 ? "text-danger" : ""}>{row.emergencies_attended} emergencias</div>
            ),
        },
        {
            dataField: "people_served_attended",
            sort: true,
            text: "Total de pacientes atendidos",
            formatter: (cell, row) => (
                <div className={row.state === 50 ? "text-danger" : ""}>{row.people_served_attended} pacientes</div>
            ),
        },
    ];

    return (
        <div className="py-4">
            <div className="row">
                <div className="mb-4 col-lg-12">
                    <div className="d-flex justify-content-between align-items-center mb-3 px-2">
                        <div>
                            <h2 className="font-weight-bold" style={{ color: "#1E2A41", fontSize: "1.75rem", margin: 0 }}>Reporte de Emergencias</h2>
                            <h6 className="text-muted" style={{ fontWeight: 500, margin: 0 }}>Listado General</h6>
                        </div>
                        <div className="text-right">
                            <h6 className="font-weight-bold m-0" style={{ color: "#2563eb", fontSize: "0.9rem" }}>Total De Emergencias</h6>
                            <h3 className="font-weight-black m-0" style={{ color: "#1E2A41", fontSize: "1.6rem", letterSpacing: "-0.5px" }}>
                                {data.results.length !== 0 ? `${data.results[0].total_emergency} Emergencias` : "0 Emergencias"}
                            </h3>
                        </div>
                    </div>
                    <div className="mb-4 card card-report-emergency shadow-sm border-0" style={{ borderRadius: '12px' }}>
                        <div className="mb-4 px-3 pt-3">
                            <div className="filters-container-rrhh m-3">
                                <div className="filters-fields-group">
                                    <Filters
                                        startDate={{
                                            show: true,
                                            start_date: start_date,
                                            setStartDate: setStartDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        endDate={{
                                            show: true,
                                            end_date: end_date,
                                            setEndDate: setEndDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        station={{
                                            show: me.role === 5 ? false : true,
                                            station: station,
                                            setStation: setStation,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "business",
                                        }}
                                        region={{
                                            show: true,
                                            region: region,
                                            filterByRegion: setRegion,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "public",
                                        }}
                                        emergency_type={{
                                            show: true,
                                            emergency_type: emergency_type_id,
                                            nameApiOptions: 'category_emergency_type',
                                            setTypeEmergency: setTypeEmergency,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "filter_list",
                                        }}
                                    />
                                </div>
                                <div className="filters-actions-group">
                                    <button
                                        className="btn font-weight-bold d-flex align-items-center justify-content-between outline-none"
                                        style={{ backgroundColor: "#e0e7ff", color: "#3b82f6", borderRadius: "30px", padding: "10px 24px", transition: "all 0.2s", fontSize: "14px", border: "none" }}
                                        onClick={descargarExcel}
                                        disabled={excelLoading || !me.station}
                                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#c7d2fe"; }}
                                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#e0e7ff"; }}
                                    >
                                        {excelLoading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            <span className="material-icons" style={{ fontSize: "18px", color: "#3b82f6" }}>insert_drive_file</span>
                                        )}
                                        <span className="mx-auto">{excelLoading ? 'Generando Excel...' : 'Exportar Excel'}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="p-0 px-3 pt-3">
                            <Grid
                                data={data}
                                loading={loader}
                                columns={columns}
                                onPageChange={listarReport}
                                noDataMessage={"Sin Puesto Registrado"}
                                trClassName="table-row-emergency"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default reduxForm({
    form: "ListEmerListReportEmergenciesgencies", // a unique identifier for this form
})(List);

// export default List;
